import * as constants from '../constants/CONSTANT';

const baseUrl = constants.API_BASE_URL + '/api/objectconfig/ai-schema-prompt-config';

function authHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('token'),
  };
}

const AiSchemaPromptConfigApi = {
  async list() {
    const response = await fetch(baseUrl, {
      method: 'GET',
      mode: 'cors',
      headers: authHeaders(),
    });
    return response.json();
  },

  async get(promptKey) {
    const response = await fetch(`${baseUrl}/${encodeURIComponent(promptKey)}`, {
      method: 'GET',
      mode: 'cors',
      headers: authHeaders(),
    });
    return response.json();
  },

  async create(payload) {
    const response = await fetch(baseUrl, {
      method: 'POST',
      mode: 'cors',
      headers: authHeaders(),
      body: JSON.stringify(payload),
    });
    return response.json();
  },

  async update(promptKey, payload) {
    const response = await fetch(`${baseUrl}/${encodeURIComponent(promptKey)}`, {
      method: 'PUT',
      mode: 'cors',
      headers: authHeaders(),
      body: JSON.stringify(payload),
    });
    return response.json();
  },

  async delete(promptKey) {
    const response = await fetch(`${baseUrl}/${encodeURIComponent(promptKey)}`, {
      method: 'DELETE',
      mode: 'cors',
      headers: authHeaders(),
    });
    return response.json();
  },
};

export default AiSchemaPromptConfigApi;
